import React from "react";

const HRAStateContext = React.createContext({});

const HRAStateProvider = HRAStateContext.Provider;

export { HRAStateContext };
export default HRAStateProvider;
